import React, { useState } from 'react';
import { ArrowRightIcon, ZapIcon, ShieldCheckIcon, TrendingUpIcon, CheckCircleIcon, SearchIcon, WrenchIcon, ShieldIcon, TruckIcon, UsersIcon, SparklesIcon, RocketIcon, FactoryIcon, GraduationCapIcon, BarChart3Icon, SmartphoneIcon, ShirtIcon, HomeIcon, BriefcaseIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
export function HomePage() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    need: '',
    budget: '',
    timeline: '',
    sendPDF: false
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value,
      type
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    }));
  };
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  const values = [{
    icon: ZapIcon,
    title: 'Speed',
    description: 'Von Anfrage zu Factory-Match in Tagen, nicht Monaten.'
  }, {
    icon: ShieldCheckIcon,
    title: 'Quality',
    description: 'Audits, Prüfpläne, europäische Standards out-of-the-box.'
  }, {
    icon: TrendingUpIcon,
    title: 'Market-Fit',
    description: 'Veredelung für EU-Design, Zertifikate & Packaging.'
  }, {
    icon: CheckCircleIcon,
    title: 'Trust',
    description: 'Vor Ort verhandelt, transparent dokumentiert.'
  }];
  const services = [{
    icon: SearchIcon,
    title: 'China Sourcing & Factory Match',
    description: 'Kuratiertes Lieferantennetz, Live-Videorundgänge, Testaufträge, NDAs.'
  }, {
    icon: WrenchIcon,
    title: 'Co-Development & Veredelung',
    description: 'Industrielles Design, Material-Upgrades, EU-Zertifikate, Packaging & Branding.'
  }, {
    icon: ShieldIcon,
    title: 'Quality & Compliance',
    description: 'AQL-Pläne, Pre-Shipment-Inspection, REACH/RoHS/CE, Dokumentation.'
  }, {
    icon: TruckIcon,
    title: 'Supply-Chain & Launch',
    description: 'Forecasting, Freight/Customs, 3PL-Setup, Rollout-Plan.'
  }];
  const steps = [{
    number: '01',
    icon: SearchIcon,
    title: 'Discovery',
    description: 'Zielbild, Business-Case, Risiko-Check'
  }, {
    number: '02',
    icon: UsersIcon,
    title: 'Factory Match',
    description: '2–3 passende Hersteller, Testmuster'
  }, {
    number: '03',
    icon: WrenchIcon,
    title: 'Co-Development',
    description: 'Iterationen, BOM/Specs, EU-Anforderungen'
  }, {
    number: '04',
    icon: SparklesIcon,
    title: 'Veredelung',
    description: 'Branding, Packaging, Zertifizierung'
  }, {
    number: '05',
    icon: RocketIcon,
    title: 'Launch',
    description: 'Logistik, Go-to-Market, After-Sales-Loop'
  }];
  const esgFeatures = [{
    icon: FactoryIcon,
    title: 'Maschinen hin, Arbeit her',
    description: 'Wir stellen passende Maschinen (z. B. Textil-/Print-/CNC-Einheiten) bereit.'
  }, {
    icon: GraduationCapIcon,
    title: 'Training & Standards',
    description: 'Lokale Teams werden geschult; Qualitäts- und Sicherheitsstandards nach EU-Norm.'
  }, {
    icon: BarChart3Icon,
    title: 'Transparenz',
    description: 'Jede Charge ist rückverfolgbar (Zeit, Ort, Lohn, CO₂-Faktor).'
  }];
  const kpis = [{
    label: 'Jobs geschaffen',
    value: 'XX'
  }, {
    label: 'Lokale Wertschöpfung',
    value: 'YY%'
  }, {
    label: 'CO₂-Intensität pro Stück',
    value: 'ZZ kg'
  }];
  const industries = [{
    icon: SmartphoneIcon,
    title: 'Consumer Electronics',
    description: 'Smart Accessories, IoT-Gadgets'
  }, {
    icon: ShirtIcon,
    title: 'Lifestyle & Merch',
    description: 'Apparel, Premium-Merch (mit Impact-Label)'
  }, {
    icon: HomeIcon,
    title: 'Home & Living',
    description: 'Küchen-Tools, Smart Home'
  }, {
    icon: BriefcaseIcon,
    title: 'B2B-Hardware',
    description: 'Prototyp → Kleinserie → Serie'
  }];
  return <div className="w-full" data-id="element-220">
      {/* Hero Section */}
      <section id="home" className="w-full bg-gradient-to-br from-[#0A122A] via-[#0A122A] to-[#0B5FFF] text-white" data-id="element-221">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32" data-id="element-222">
          <div className="max-w-4xl" data-id="element-223">
            <h1 className="text-5xl lg:text-7xl font-bold mb-6 leading-tight" data-id="element-224">
              Von der Idee zum Produkt: schnell, hochwertig, marktreif.
            </h1>
            <p className="text-xl lg:text-2xl mb-8 text-gray-200 leading-relaxed" data-id="element-225">
              FJT verbindet die Innovationskraft Chinas mit europäischer
              Präzision. Wir sourcen, entwickeln weiter und bringen Produkte
              veredelt nach Europa.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-226">
              <button onClick={scrollToContact} className="inline-flex items-center justify-center px-8 py-4 bg-[#00C389] text-white rounded-lg font-semibold hover:bg-[#00a876] transition-colors text-lg" data-id="element-227">
                Kostenloses Erstgespräch buchen
                <ArrowRightIcon className="ml-2" size={20} data-id="element-228" />
              </button>
              <button onClick={scrollToContact} className="inline-flex items-center justify-center px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-lg font-semibold hover:bg-white/20 transition-colors text-lg border border-white/20" data-id="element-229">
                Sourcing Readiness Check starten
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* Stats Bar */}
      <section className="w-full bg-[#0B5FFF] text-white py-8" data-id="element-230">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-6 text-center lg:text-left" data-id="element-232">
            <div className="flex items-center gap-2" data-id="element-233">
              <span className="text-sm font-medium" data-id="element-234">
                2× schneller zum Factory-Match
              </span>
            </div>
            <div className="hidden lg:block w-px h-6 bg-white/30" data-id="element-235"></div>
            <div className="flex items-center gap-2" data-id="element-236">
              <span className="text-sm font-medium" data-id="element-237">
                EU-Standards by default
              </span>
            </div>
            <div className="hidden lg:block w-px h-6 bg-white/30" data-id="element-238"></div>
            <div className="flex items-center gap-2" data-id="element-239">
              <span className="text-sm font-medium" data-id="element-240">Transparente Audits</span>
            </div>
          </div>
        </div>
      </section>
      {/* Value Propositions */}
      <section className="w-full bg-white py-24" data-id="element-241">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-242">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-243">
            {values.map((value, index) => {
            const Icon = value.icon;
            return <div key={index} className="group" data-id="element-244">
                  <div className="bg-[#F5F7FB] rounded-2xl p-8 h-full transition-all hover:shadow-lg hover:-translate-y-1" data-id="element-245">
                    <div className="w-14 h-14 bg-[#0B5FFF] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-246">
                      <Icon className="text-white" size={28} data-id="element-247" />
                    </div>
                    <h3 className="text-xl font-bold mb-3 text-[#0A122A]" data-id="element-248">
                      {value.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed" data-id="element-249">
                      {value.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </section>
      {/* Services Section */}
      <section id="services" className="w-full bg-[#F5F7FB] py-24" data-id="element-250">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-251">
          <div className="text-center mb-16" data-id="element-252">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-[#0A122A]" data-id="element-253">
              Leistungen
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-254">
              Modular buchbar – oder als End-to-End-Sprint bis zur
              Markteinführung.
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-255">
            {services.map((service, index) => {
            const Icon = service.icon;
            return <div key={index} className="bg-white rounded-2xl p-10 hover:shadow-xl transition-all" data-id="element-256">
                  <div className="w-16 h-16 bg-[#0B5FFF] rounded-xl flex items-center justify-center mb-6" data-id="element-257">
                    <Icon className="text-white" size={32} data-id="element-258" />
                  </div>
                  <h3 className="text-2xl font-bold mb-4 text-[#0A122A]" data-id="element-259">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed text-lg" data-id="element-260">
                    {service.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </section>
      {/* Process Section */}
      <section id="process" className="w-full bg-white py-24" data-id="element-261">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-262">
          <div className="text-center mb-16" data-id="element-263">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-[#0A122A]" data-id="element-264">
              Prozess
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-265">
              Von der Idee bis zum Launch – strukturiert, transparent, schnell.
            </p>
          </div>
          {/* Desktop Timeline View */}
          <div className="hidden lg:block relative" data-id="element-266">
            <div className="grid grid-cols-5 gap-4" data-id="element-267">
              {steps.map((step, index) => {
              const Icon = step.icon;
              return <div key={index} className="relative" data-id="element-268">
                    {/* Card */}
                    <div className="bg-white border-2 border-gray-100 rounded-2xl p-6 hover:border-[#0B5FFF] hover:shadow-xl transition-all group" data-id="element-269">
                      {/* Step Number */}
                      <div className="text-right mb-2" data-id="element-270">
                        <span className="text-3xl font-bold text-[#0B5FFF] opacity-30" data-id="element-271">
                          {step.number}
                        </span>
                      </div>
                      {/* Icon Circle */}
                      <div className="w-16 h-16 bg-gradient-to-br from-[#0B5FFF] to-[#00C389] rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform relative z-10" data-id="element-272">
                        <Icon className="text-white" size={28} data-id="element-273" />
                      </div>
                      {/* Content */}
                      <h3 className="text-lg font-bold text-center mb-2 text-[#0A122A]" data-id="element-274">
                        {step.title}
                      </h3>
                      <p className="text-sm text-gray-600 text-center leading-relaxed" data-id="element-275">
                        {step.description}
                      </p>
                    </div>
                  </div>;
            })}
            </div>
          </div>
          {/* Mobile Stacked View */}
          <div className="lg:hidden space-y-6" data-id="element-276">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <div key={index} className="relative" data-id="element-277">
                  <div className="bg-gradient-to-br from-[#F5F7FB] to-white rounded-2xl p-8 border-2 border-gray-100 hover:border-[#0B5FFF] transition-all" data-id="element-278">
                    <div className="flex items-start gap-6" data-id="element-279">
                      {/* Icon */}
                      <div className="flex-shrink-0" data-id="element-280">
                        <div className="w-16 h-16 bg-gradient-to-br from-[#0B5FFF] to-[#00C389] rounded-2xl flex items-center justify-center" data-id="element-281">
                          <Icon className="text-white" size={28} data-id="element-282" />
                        </div>
                      </div>
                      {/* Content */}
                      <div className="flex-1" data-id="element-283">
                        <div className="flex items-center gap-3 mb-3" data-id="element-284">
                          <span className="text-4xl font-bold text-[#0B5FFF] opacity-20" data-id="element-285">
                            {step.number}
                          </span>
                          <h3 className="text-2xl font-bold text-[#0A122A]" data-id="element-286">
                            {step.title}
                          </h3>
                        </div>
                        <p className="text-lg text-gray-600 leading-relaxed" data-id="element-287">
                          {step.description}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </section>
      {/* Industries Section */}
      <section id="industries" className="w-full bg-white py-24" data-id="element-288">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-289">
          <div className="text-center mb-16" data-id="element-290">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-[#0A122A]" data-id="element-291">
              Branchen & Use-Cases
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-292">
              Von Consumer Electronics bis B2B-Hardware – wir kennen die
              Anforderungen.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-293">
            {industries.map((industry, index) => {
            const Icon = industry.icon;
            return <div key={index} className="bg-[#F5F7FB] rounded-2xl p-10 hover:shadow-xl transition-all group" data-id="element-294">
                  <div className="w-16 h-16 bg-[#0B5FFF] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-295">
                    <Icon className="text-white" size={32} data-id="element-296" />
                  </div>
                  <h3 className="text-2xl font-bold mb-3 text-[#0A122A]" data-id="element-297">
                    {industry.title}
                  </h3>
                  <p className="text-gray-600 text-lg" data-id="element-298">
                    {industry.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </section>
      {/* ESG Section */}
      <section id="esg" className="w-full bg-[#F5F7FB] py-24" data-id="element-299">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-300">
          <div className="text-center mb-16" data-id="element-301">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-[#0A122A]" data-id="element-302">
              ESG & Impact
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-303">
              Wertschöpfung mit Wirkung – fair, messbar, skalierbar.
            </p>
          </div>
          <div className="max-w-4xl mx-auto mb-20" data-id="element-304">
            <p className="text-xl text-gray-600 leading-relaxed text-center" data-id="element-305">
              Unter ESG versteht FJT nicht nur Audits und Zertifikate. Wir
              verlagern aktiv Merch-Produktion auf maschinenbasierte
              Micro-Factories, die wir in strukturschwache Regionen bringen. So
              entstehen lokale Jobs, Qualifizierung und Einkommen – transparent
              getrackt.
            </p>
          </div>
          <div className="mb-20" data-id="element-306">
            <h3 className="text-3xl font-bold mb-12 text-center text-[#0A122A]" data-id="element-307">
              So funktioniert's
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-308">
              {esgFeatures.map((feature, index) => {
              const Icon = feature.icon;
              return <div key={index} className="text-center bg-white rounded-2xl p-8" data-id="element-309">
                    <div className="w-20 h-20 bg-[#00C389] rounded-2xl flex items-center justify-center mx-auto mb-6" data-id="element-310">
                      <Icon className="text-white" size={36} data-id="element-311" />
                    </div>
                    <h3 className="text-xl font-bold mb-3 text-[#0A122A]" data-id="element-312">
                      {feature.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed" data-id="element-313">
                      {feature.description}
                    </p>
                  </div>;
            })}
            </div>
          </div>
          <div className="bg-white rounded-3xl p-12" data-id="element-314">
            <h3 className="text-3xl font-bold mb-8 text-center text-[#0A122A]" data-id="element-315">
              Impact KPIs
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-316">
              {kpis.map((kpi, index) => <div key={index} className="text-center" data-id="element-317">
                  <div className="text-5xl font-bold text-[#0B5FFF] mb-3" data-id="element-318">
                    {kpi.value}
                  </div>
                  <div className="text-gray-600 font-medium" data-id="element-319">{kpi.label}</div>
                </div>)}
            </div>
            <p className="text-center text-gray-500 mt-8" data-id="element-320">
              Audit-Quote & Fair-Pay-Index als Dashboard
            </p>
          </div>
        </div>
      </section>
      {/* About Section */}
      <section id="about" className="w-full bg-[#F5F7FB] py-24" data-id="element-321">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-322">
          <div className="text-center mb-16" data-id="element-323">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-[#0A122A]" data-id="element-324">
              Über FJT
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-325">
              Die Brücke zwischen Chinas Geschwindigkeit und Europas
              Marktanforderungen.
            </p>
          </div>
          <div className="mb-20" data-id="element-326">
            <h3 className="text-3xl font-bold mb-6 text-[#0A122A] text-center" data-id="element-327">
              Unsere Geschichte
            </h3>
            <p className="text-xl text-gray-600 leading-relaxed mb-6 text-center" data-id="element-328">
              FJT wurde nach einer Delegationsreise nach China gegründet –
              inspiriert von der dort erlebten Geschwindigkeit, Klarheit und
              technologischen Exzellenz.
            </p>
            <p className="text-xl text-gray-600 leading-relaxed text-center" data-id="element-329">
              Wir bringen diese Energie nach Europa – verantwortungsvoll,
              messbar, wirkungsvoll.
            </p>
          </div>
          <div className="bg-white rounded-3xl p-12" data-id="element-330">
            <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-331">
              <div className="flex-shrink-0" data-id="element-332">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/m64e6tCHisr1PiAz2wkXWK/422156636_122097199310199102_1491025504153642636_n.jpg" alt="Sven" className="w-48 h-48 rounded-2xl object-cover" data-id="element-333" />
              </div>
              <div className="flex-1" data-id="element-334">
                <h3 className="text-3xl font-bold mb-6 text-[#0A122A]" data-id="element-335">
                  Sven Schulte, MBA
                </h3>
                <ul className="space-y-4 text-lg text-gray-600" data-id="element-336">
                  <li className="flex items-start" data-id="element-337">
                    <span className="text-[#0B5FFF] mr-3" data-id="element-338">•</span>
                    <span data-id="element-339">
                      25 Jahre Tech-Know How und Erfahrung in der
                      Produktentwicklung
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-340">
                    <span className="text-[#0B5FFF] mr-3" data-id="element-341">•</span>
                    <span data-id="element-342">
                      Etabliertes Netzwerk zu führenden Herstellern in China
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-343">
                    <span className="text-[#0B5FFF] mr-3" data-id="element-344">•</span>
                    <span data-id="element-345">
                      Tiefes Verständnis für europäische Marktanforderungen
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Section */}
      <section id="contact" className="w-full bg-white py-24" data-id="element-346">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-347">
          <div className="text-center mb-16" data-id="element-348">
            <h2 className="text-4xl lg:text-5xl font-bold mb-6 text-[#0A122A]" data-id="element-349">
              Kontakt
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-350">
              Lassen Sie uns über Ihr Projekt sprechen. Antwort binnen 24h
              (werktags).
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-351">
            <div data-id="element-352">
              <h3 className="text-3xl font-bold mb-8 text-[#0A122A]" data-id="element-353">
                Kontaktieren Sie uns
              </h3>
              <div className="space-y-6 mb-12" data-id="element-354">
                <div className="flex items-start gap-4" data-id="element-355">
                  <div className="w-12 h-12 bg-[#0B5FFF] rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-356">
                    <MapPinIcon className="text-white" size={24} data-id="element-357" />
                  </div>
                  <div data-id="element-358">
                    <h4 className="font-semibold text-lg mb-1 text-[#0A122A]" data-id="element-359">
                      Standorte
                    </h4>
                    <p className="text-gray-600" data-id="element-360">Hamburg, Deutschland</p>
                    <p className="text-gray-600" data-id="element-361">Guangzhou, China</p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-362">
                  <div className="w-12 h-12 bg-[#0B5FFF] rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-363">
                    <MailIcon className="text-white" size={24} data-id="element-364" />
                  </div>
                  <div data-id="element-365">
                    <h4 className="font-semibold text-lg mb-1 text-[#0A122A]" data-id="element-366">
                      E-Mail
                    </h4>
                    <p className="text-gray-600" data-id="element-367">info@fj-technologies.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-368">
                  <div className="w-12 h-12 bg-[#0B5FFF] rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-369">
                    <PhoneIcon className="text-white" size={24} data-id="element-370" />
                  </div>
                  <div data-id="element-371">
                    <h4 className="font-semibold text-lg mb-1 text-[#0A122A]" data-id="element-372">
                      Telefon
                    </h4>
                    <p className="text-gray-600" data-id="element-373">+49 (0) 40 60 77 685 55</p>
                  </div>
                </div>
              </div>
              <div className="bg-[#F5F7FB] rounded-2xl p-8" data-id="element-374">
                <h4 className="text-xl font-bold mb-4 text-[#0A122A]" data-id="element-375">
                  Antwortzeit
                </h4>
                <p className="text-gray-600" data-id="element-376">
                  Wir antworten innerhalb von 24 Stunden (werktags) auf alle
                  Anfragen.
                </p>
              </div>
            </div>
            <div data-id="element-377">
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-378">
                <div data-id="element-379">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-380">
                    Name *
                  </label>
                  <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0B5FFF] focus:border-transparent" data-id="element-381" />
                </div>
                <div data-id="element-382">
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-383">
                    Firma *
                  </label>
                  <input type="text" id="company" name="company" required value={formData.company} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0B5FFF] focus:border-transparent" data-id="element-384" />
                </div>
                <div data-id="element-385">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-386">
                    E-Mail *
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0B5FFF] focus:border-transparent" data-id="element-387" />
                </div>
                <div data-id="element-388">
                  <label htmlFor="need" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-389">
                    Produktidee / Bedarf *
                  </label>
                  <textarea id="need" name="need" required rows={4} value={formData.need} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0B5FFF] focus:border-transparent" data-id="element-390" />
                </div>
                <div data-id="element-391">
                  <label htmlFor="budget" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-392">
                    Budget-Range
                  </label>
                  <select id="budget" name="budget" value={formData.budget} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0B5FFF] focus:border-transparent" data-id="element-393">
                    <option value="" data-id="element-394">Bitte wählen</option>
                    <option value="under-50k" data-id="element-395">Unter 50.000 €</option>
                    <option value="50k-100k" data-id="element-396">50.000 € - 100.000 €</option>
                    <option value="100k-250k" data-id="element-397">100.000 € - 250.000 €</option>
                    <option value="over-250k" data-id="element-398">Über 250.000 €</option>
                  </select>
                </div>
                <div data-id="element-399">
                  <label htmlFor="timeline" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-400">
                    Timeline
                  </label>
                  <select id="timeline" name="timeline" value={formData.timeline} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0B5FFF] focus:border-transparent" data-id="element-401">
                    <option value="" data-id="element-402">Bitte wählen</option>
                    <option value="asap" data-id="element-403">So schnell wie möglich</option>
                    <option value="1-3months" data-id="element-404">1-3 Monate</option>
                    <option value="3-6months" data-id="element-405">3-6 Monate</option>
                    <option value="6plus" data-id="element-406">6+ Monate</option>
                  </select>
                </div>
                <div className="flex items-center" data-id="element-407">
                  <input type="checkbox" id="sendPDF" name="sendPDF" checked={formData.sendPDF} onChange={handleChange} className="w-5 h-5 text-[#0B5FFF] border-gray-300 rounded focus:ring-[#0B5FFF]" data-id="element-408" />
                  <label htmlFor="sendPDF" className="ml-3 text-sm text-gray-700" data-id="element-409">
                    PDF-Leistungsübersicht zusenden
                  </label>
                </div>
                <button type="submit" className="w-full px-8 py-4 bg-[#0B5FFF] text-white rounded-lg font-semibold hover:bg-[#0952d9] transition-colors text-lg" data-id="element-410">
                  Gespräch buchen
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* Footer CTA */}
      <section className="w-full bg-[#0A122A] text-white py-24" data-id="element-411">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-412">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6" data-id="element-413">
            FJT bringt Zukunftsprodukte schneller auf den europäischen Markt
          </h2>
          <p className="text-xl text-gray-300 mb-8" data-id="element-414">
            Mit China-Speed, EU-Qualität und messbarem Impact.
          </p>
          <button onClick={scrollToContact} className="inline-flex items-center px-8 py-4 bg-[#00C389] text-white rounded-lg font-semibold hover:bg-[#00a876] transition-colors text-lg" data-id="element-415">
            Jetzt Projekt anstoßen
            <ArrowRightIcon className="ml-2" size={20} data-id="element-416" />
          </button>
        </div>
      </section>
      <Footer data-id="element-417" />
    </div>;
}